// removed by extract-text-webpack-plugin
module.exports = {"PartnersPage":"_27W2ld5e"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/partners/partners-page.styles.scss
// module id = 518
// module chunks = 0